module.exports = __webpack_public_path__ + "img/47.8cf541ca.jpg";